/**
 * Creates an onChange handler with a key. The key should be known by the parent.
 * With this the parent knows what card was updated en show an "unsaved changes" accordingly
 */
export const createOnChange = <T>(onChange: (key: string) => void, key: keyof T) => (e?) => onChange(key as string);
